<template>
    <div class="loginContent">
        <el-form :rules="rules" ref="ruleForm" :model="ruleForm">
            <el-form-item prop="pwd">
                <span class="iconfont iconicon_dl_mima"></span>
                <el-input v-model="ruleForm.pwd" placeholder="请输入密码" type="password" autocomplete="new-password" show-password></el-input>
            </el-form-item>
            <el-form-item prop="pwdAgain">
                <span class="iconfont iconicon_dl_mima"></span>
                <el-input v-model="ruleForm.pwdAgain" placeholder="请再次输入密码" type="password" autocomplete="new-password" show-password></el-input>
            </el-form-item>
            <div class="protocol" style="font-size:10px;"><i class="el-icon-warning" style="color:#81b1dd"/>密码必须以字母开头，必须包含数字、特殊字符，长度不小于8位</div>
        </el-form>
        <div :class="isReading ? 'active protocol' : 'protocol'" style="margin-top:10px;">
            <!-- <el-checkbox @change="reading"></el-checkbox>
            我已同意并阅读
            <span class="weight" @click="seeRules">《服务协议条款》</span> -->
        </div>
        <el-button type="primary" @click="changeParentTitle('密码登录', 'pwd')" :disabled="!canRegester"  :loading='registering'>注册</el-button>
    </div>
</template>
<script>
import { register } from '../../../axios/user'
import { validatePwd } from '../components/verification'
export default {
    props: {
        // loginType: String
    },
    data () {
        var verificationPwd2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'))
            } else if (value !== this.ruleForm.pwd) {
                callback(new Error('两次输入密码不一致!'))
            } else {
                callback()
            }
        }
        return {
            ruleForm: {
                pwd: '',
                pwdAgain: ''
            },
            isReading: true,
            registering:false,
            rules: {
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 8, message: '密码最少为8位', trigger: 'blur' },
                    {validator:this.validatePassWord, trigger: 'blur'}
                ],
                pwdAgain: [
                    { validator: verificationPwd2, trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        changeParentTitle (val, type) {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.registering = true;
            let tel = window.localStorage.getItem('tel')
            // let code = window.localStorage.getItem('code')
            let token = window.localStorage.getItem('token')
            const pwd = this.$store.state.jsEnc.encrypt(`${this.ruleForm.pwd},${Date.now()}`)
            register(tel, pwd, token).then(({data}) => {
                if (data.success) {
                    // this.$emit('changeLoginType', val, type)
                    // this.$message.success('注册成功！请登录')
                    window.localStorage.removeItem('tel')
                    window.localStorage.removeItem('code')
                    window.localStorage.removeItem('token')
                    this.$postMessage('messgeFromAuth',{
                     type:'success',
                     msg:"注册成功！请登录"
                    })
                }
            }).finally(()=>{
                this.registering = false;
            })
          } else {
            return false;
          }
        });
           
        },
        reading (val) {
            this.isReading = val
        },
        seeRules () {
            let newPage = this.$router.resolve({
                name: 'privacyRules'
            })
            window.open(newPage.href, '_blank')
        },
        validatePassWord(rule, value, callback){
             if (validatePwd(value)) {
                callback();
             } else {
                callback(new Error('密码必须以字母开头，必须包含数字、特殊字符，长度不小于8位'));
             }
        }
    },
    computed: {
        canRegester () {
            return (!!(this.ruleForm.pwd.length > 7) && !!(this.ruleForm.pwd === this.ruleForm.pwdAgain) && this.isReading)
        }
    },
    beforeDestroy () {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('tel')
        window.localStorage.removeItem('code')
    }
}
</script>
<style scoped lang="scss">
.loginContent {
    padding-top: 30px;
    .el-form-item {
        margin-bottom: 20px;

        .iconfont {
            position: absolute;
            left: 12px;
            top: 14px;
            font-size: 18px;
            line-height: 18px;
            color: #ccc;
            z-index: 1;
        }
    }

    .protocol {
        font-size: 14px;
        line-height: 16px;
        color: #999999;
        font-family: PingFangSC-Regular, PingFang SC;

        .weight {
            color: #666666;
            cursor: pointer;
        }

        .weight:hover {
            color: #0263BB;
        }
    }

    .protocol.active {
        color: #0263BB;
    }

    button {
        width: 100%;
        height: 46px;
        margin-top: 60px;
        background: #0263BB;
        border-color: #0263BB;
    }
}
</style>
<style lang="scss">
.loginContent {

    .protocol {

        .el-checkbox {
            height: 16px;

            .el-checkbox__input.is-checked .el-checkbox__inner {
                background-color: #0263BB;
                border-color: #0263BB;
            }

            .el-checkbox__inner:hover, .is-focus {
                border-color: #0263BB;
            }

            .is-focus .el-checkbox__inner {
                border-color: #0263BB;
            }
        }
    }

}
</style>
